<template>
    <div class="steps__wrapper">
        <span class="active-step">{{ activeStep }}</span> <span> {{ $t('OF_2') }} {{ steps }}</span>

        <div class="steps hidden-xs-only">
            <div
                class="step-dot"
                v-for="(index, step) in steps"
                :key="index"
                :class="{ 'step-dot--active': isActiveStep(index) }"
            >
                <div class="dot" :class="{ last: isLastStep(index) }"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        steps: Number,
        activeStep: Number,
    },
    data() {
        return {};
    },
    methods: {
        isActiveStep(idx) {
            return idx <= this.activeStep;
        },
        isLastStep(idx) {
            return idx === this.steps;
        },
    },
};
</script>

<style lang="scss" scoped>
.steps__wrapper {
    align-items: center;
    color: #222;
    display: flex;
    margin-top: 50px;
    font-size: 16px;
    font-weight: 300;
    justify-content: center;

    @media (max-width: 767px) {
        margin-top: 20px;
    }
}

.active-step {
    color: #cf004a;
    margin-right: 5px;
}

.steps {
    display: inline-flex;
    margin-left: 15px;
    margin-right: 42px;
    position: relative;

    &:before {
        content: '';
        height: 1px;
        background: #f1eeea;
        width: 100%;
        top: 50%;
        position: absolute;
        z-index: 1;
        transform: translateY(-50%);
    }
}

.step-dot {
    border-radius: 50%;
    border: 1px solid #f1eeea;
    box-sizing: border-box;
    background-color: #ffffff;
    width: 40px;
    height: 40px;
    padding: 5px;
    margin: 0 12px 0 0;
    z-index: 20;

    &:last-child {
        margin-right: 0;
    }

    .dot {
        border-radius: 50%;
        background-color: #f1eeea;
        width: 28px;
        height: 28px;

        &.last {
            background-color: transparent;
            background-image: url('/src/assets/images/icons/smile-in-dot.svg');
        }
    }

    &--active {
        .dot {
            background-color: #cf004a;

            &.last {
                background-color: transparent;
                background-image: url('/src/assets/images/icons/smile-red.svg');
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// steps.vue?3df73102